var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-container',[_c('v-card',[_c('dog-split',{attrs:{"dogClass":_vm.dogClass}})],1),_c('class-from-text'),_c('div',{staticStyle:{"height":"200px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }